<div *ngIf="net">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>bookmark</mat-icon> {{!net.id ? 'Create new Network Type' : ('Network Type ' + net.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{!net.id ? 'add' : 'save'}}</mat-icon>
        {{(net.id ? 'Update ' : 'Add ')}}
      </button>
      <micro-delete-confirm *ngIf="net.id" (onConfirm)="delete()"></micro-delete-confirm>
    </div>
  </div>

  <div class="padded vbox-space">
    <div>
      <form #form="ngForm" role="form" class="vbox">
        <table class="basicTable">
          <thead>
          <tr>
            <th colspan="100">Network Type Configuration</th>
          </tr>
          <tr>
            <th *ngIf="authService.isCompanyAdmin()">Company</th>
            <th>Name</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td *ngIf="authService.isCompanyAdmin()">
              <micro-company-select [(companyId)]="net.companyId" [required]="true" [jump]="false"></micro-company-select>
            </td>
            <td>
              <input [(ngModel)]="net.name" required type="text" placeholder="Name" id="name" name="name">
            </td>
          </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</div>
